import { render, staticRenderFns } from "./export-receipts.vue?vue&type=template&id=ca39a10a&scoped=true&"
import script from "./export-receipts.vue?vue&type=script&lang=js&"
export * from "./export-receipts.vue?vue&type=script&lang=js&"
import style0 from "./export-receipts.vue?vue&type=style&index=0&id=ca39a10a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca39a10a",
  null
  
)

export default component.exports